import { render, staticRenderFns } from "./Icon2d.vue?vue&type=template&id=ae9b0580&scoped=true"
import script from "./Icon2d.vue?vue&type=script&lang=js"
export * from "./Icon2d.vue?vue&type=script&lang=js"
import style0 from "./Icon2d.vue?vue&type=style&index=0&id=ae9b0580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9b0580",
  null
  
)

export default component.exports